module.exports = __webpack_public_path__ + "img/sec1.291ca183.png";